function getOrderOnlineLink(title) {
  const linkMap = {
    "foodyard-calgary-kensington": "https://orders.iorders.online/foodyard-kensington-calgary-5277/",
    "foodyard-calgary-sage-hill": "https://orders.iorders.online/foodyard-calgary-5341/",
    "foodyard-calgary-carrington": "https://orders.iorders.online/foodyard-calgary/",
  };

  return linkMap[title] || "N/A";
}

const storeDetails = {
  status: "success",
  data: {
    restaurants: [

      //1. Foodyard Calgary Kensington
      // {
      //   profile: {
      //     id: 2002,
      //     restaurant_name: "Foodyard Calgary Kensington",
      //     title: "foodyard-calgary-kensington",
      //     address: "405 10 St NW, Calgary, AB T2N 4J3",
      //     phone: "(403) 454-0510",
      //     available_days: [
      //       { id: 20021, day: "SUNDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20022, day: "MONDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20023, day: "TUESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20024, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20025, day: "THURSDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20026, day: "FRIDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20027, day: "SATURDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //     ],
      //     close_restaurent: false,
      //     lat: "51.0556531964574",
      //     lng: "-114.08570998805214",
      //     get order_online_link() {
      //       return getOrderOnlineLink(this.title);
      //     },
      //   },
      // },


      


      


      //4. Foodyard Calgary Carrington
      {
        profile: {
          id: 2001,
          restaurant_name: "Foodyard Calgary Carrington",
          title: "foodyard-calgary-carrington",
          address: "45 Carrington Blvd #165, Calgary, AB T3P 1K8",
          phone: "(306) 316-1613",
          available_days: [
            { id: 20011, day: "SUNDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 20012, day: "MONDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 20013, day: "MONDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 20014, day: "TUESDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 20015, day: "TUESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 20016, day: "WEDNESDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 20017, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 20018, day: "THURSDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 20019, day: "THURSDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 200110, day: "FRIDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 200111, day: "FRIDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 200112, day: "SATURDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
            { id: 200113, day: "SATURDAY", opening_time: "11:00:00", closing_time: "24:00:00", order_mode: 1 },
            { id: 200114, day: "SUNDAY", opening_time: "00:00:00", closing_time: "03:00:00", order_mode: 1 },
          ],
          close_restaurent: false,
          lat: "51.18303900512446",
          lng: "-114.07332983968583",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Foodyard Calgary Sage Hill
      // {
      //   profile: {
      //     id: 2003,
      //     restaurant_name: "Foodyard Calgary Sage Hill",
      //     title: "foodyard-calgary-sage-hill",
      //     address: "66 Sage Hill Passage NW, Calgary, AB T3R 0S4",
      //     phone: "(905) 781-8920",
      //     available_days: [
      //       { id: 20031, day: "SUNDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20032, day: "MONDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20033, day: "TUESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20034, day: "WEDNESDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20035, day: "THURSDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20036, day: "FRIDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //       { id: 20037, day: "SATURDAY", opening_time: "11:00:00", closing_time: "23:00:00", order_mode: 1 },
      //     ],
      //     close_restaurent: false,
      //     temporarily_closed: true,
      //     lat: "51.17015829644118",
      //     lng: "-114.14638010324063",
      //     get order_online_link() {
      //       return getOrderOnlineLink(this.title);
      //     },
      //   },
      // },
//3. Foodyard Toronto (Coming Soon)
      // {
      //   profile: {
      //     id: 2004,
      //     restaurant_name: "Foodyard Toronto",
      //     title: "foodyard-toronto",
      //     address: "Toronto, ON, Canada",
      //     phone: "N/A",
      //     available_days: [],
      //     close_restaurent: true,
      //     lat: "43.651070",
      //     lng: "-79.347015",
      //     get order_online_link() {
      //       return getOrderOnlineLink(this.title);
      //     },
      //   },
      // },
    ],
  },
  message: "successful response",
};

export default storeDetails;
